import { render } from "./ParamListPageList.vue?vue&type=template&id=5aaf8d5c&scoped=true&ts=true"
import script from "./ParamListPageList.vue?vue&type=script&lang=ts"
export * from "./ParamListPageList.vue?vue&type=script&lang=ts"

import "./ParamListPageList.vue?vue&type=style&index=0&id=5aaf8d5c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaf8d5c"]])

export default __exports__